'use strict';

import GoogleIcon from 'Icons/Google';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
export default function GoogleButton(props) {
  const loader = props.loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['google', 'bg-google']
  }) : undefined;
  let class_name = bemit('c-flat-btn', ['google'].concat(props.bemit || []));
  if (props.className) class_name += ' ' + props.className;
  const output = /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: props.onClick,
    className: class_name
  }, /*#__PURE__*/React.createElement(GoogleIcon, {
    className: "c-flat-btn__google-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "u-flex-grow-1 u-text-center"
  }, props.text || 'Se connecter avec Google'), loader);
  return output;
}
